import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import img from '../img/logo.png'; 

const Navbar = ({ setActiveTab }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // دالة مساعدة لتغيير القسم وإغلاق المنيو في الموبايل
  const handleNavClick = (tab) => {
    setActiveTab(tab);
    // إغلاق المنيو تلقائياً عند الضغط (للنسخة الموبايل)
    const navbarCollapse = document.getElementById('navbarNav');
    if (navbarCollapse.classList.contains('show')) {
      navbarCollapse.classList.remove('show');
    }
  };

  return (
    <motion.nav 
      className={`navbar navbar-expand-lg fixed-top ${scrolled ? 'scrolled' : ''}`}
      initial={{ y: -100, opacity: 0 }} 
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 2.8, ease: "easeOut" }}
    >
      <div className="container-fluid">
        <button className="navbar-brand" style={{background:'none', border:'none'}} onClick={() => handleNavClick('home')}>
          <img src={img} alt="Logo" style={{ height: '40px' }} />
        </button>
        
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <button className="nav-link" onClick={() => handleNavClick('home')}>الرئيسية</button>
            </li>
            <li className="nav-item">
              <button className="nav-link" onClick={() => handleNavClick('about')}>من نحن</button>
            </li>
            <li className="nav-item">
              <button className="nav-link" onClick={() => handleNavClick('portfolio')}>المنتجات</button>
            </li>
            <li className="nav-item">
              <button className="nav-link" onClick={() => handleNavClick('contact')}>تواصل معنا</button>
            </li>
          </ul>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;